<template>
  <div class="ec-line003" v-loading="loading">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <a :href="baseUrl">{{ this.shopName }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: $routePage.EC_LINE001 }">
        {{ $t('ec-line001.content.listOfProductsHandled') }}</el-breadcrumb-item
      >
      <el-breadcrumb-item>
        <h1 class="m-0 text-lg font-normal">
          {{
            $t('ec-line003.breadcrumpTitle', {
              type:
                tab === EC_LINE003.TABS_TYPE.SUBSCRIPTION
                  ? $t('ec-line003.tab.subscription')
                  : $t('ec-line003.tab.normal'),
            })
          }}
        </h1></el-breadcrumb-item
      >
    </el-breadcrumb>
    <el-row>
      <el-tabs v-model="tab" @tab-click="handleTabClick">
        <el-tab-pane :label="$t('ec-line003.tab.subscription')" :name="EC_LINE003.TABS_TYPE.SUBSCRIPTION">
          <el-form ref="subscriptionForm" :model="form">
            <cart-list
              v-if="subscriptionCarts.length && subscriptionCartsSummary"
              v-loading="componentLoading"
              :items="subscriptionCarts"
              key="subscriptionListCart"
              :free-amount="freeAmount"
              :summary="subscriptionCartsSummary"
              :lup-sum-valid-flag="validatelumpSumPayment"
            >
              <template #default="{ items }">
                <item-table
                  class="hidden lg:block"
                  :data="subscriptionCarts"
                  is-subscription
                  @update-quantity="updateQuantity"
                  @remove="removeItem"
                />
                <cart-list-item
                  v-for="(item, idx) in items"
                  class="block lg:hidden"
                  :key="idx"
                  :data="item"
                  :index="idx"
                  is-subscription
                  @update-quantity="updateQuantity"
                  @remove="removeItem"
                />
              </template>
            </cart-list>

            <div v-else class="font-black text-xl lg:text-lg text-center my-28">
              {{ $t('ec-line003.content.noItem') }}
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('ec-line003.tab.normal')" :name="EC_LINE003.TABS_TYPE.NORMAL">
          <el-form ref="normalForm" :model="form">
            <cart-list
              v-if="normalCarts.length && normalCartsSummary"
              v-loading="componentLoading"
              :items="normalCarts"
              key="normalListCart"
              :free-amount="freeAmount"
              :summary="normalCartsSummary"
              :lup-sum-valid-flag="validatelumpSumPayment"
            >
              <template #default="{ items }">
                <item-table
                  class="hidden lg:block"
                  :data="normalCarts"
                  @update-quantity="updateQuantity"
                  @remove="removeItem"
                />
                <cart-list-item
                  v-for="(item, idx) in items"
                  class="block lg:hidden"
                  :key="idx"
                  :data="item"
                  :index="idx"
                  @update-quantity="updateQuantity"
                  @remove="removeItem"
                />
              </template>
            </cart-list>
            <div v-else class="font-black text-xl lg:text-lg text-center my-28">
              {{ $t('ec-line003.content.noItem') }}
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-row type="flex" justify="center" class="mt-6"> </el-row>

    <div class="flex flex-wrap justify-center lg:my-4 my-1">
      <el-button
        v-if="isNotEmptyCart"
        :disabled="validatelumpSumPayment || !summaryStatus || !hasCartItemQuantity"
        class="submit-btn lg:ml-6 lg:order-1"
        @click="toCashRegiter"
      >
        {{ $t('ec-line003.content.nextStepBtn') }}
      </el-button>
      <el-button v-else class="submit-btn lg:ml-6 lg:order-1" @click="toProductPage">{{
        $t('ec-line003.content.toProductBtn')
      }}</el-button>

      <el-button class="cancel-btn mt-8 lg:my-0" @click="$router.go(-1)">{{ $t('common.action.back') }}</el-button>
    </div>
  </div>
</template>

<script>
import CartList from '@/components/ec-line003/CartList.vue'
import CartListItem from '@/components/ec-line003/CartListItem.vue'
import ItemTable from '@/components/ec-line003/ItemTable.vue'
import { CartService, ProductService } from '@/services'
import { syncCart, removeEmptyQueryString } from '@/utils'
import { ENV_KEY } from '@/constants/env'
import amazonMixin from '@/mixins/amazonV2'
import BreadcrumbMixin from '@/mixins/breadcrumb'
import { AMAZON } from '@/constants/amazon'
import { SALE_TYPE } from '@/constants'

const EC_LINE003 = {
  TABS_TYPE: {
    NORMAL: 'normal',
    SUBSCRIPTION: 'subscription',
  },
}

export default {
  mixins: [amazonMixin, BreadcrumbMixin],
  components: { CartList, CartListItem, ItemTable },
  props: {
    abmtcd: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      tab: EC_LINE003.TABS_TYPE.SUBSCRIPTION,
      EC_LINE003,
      loading: false,
      componentLoading: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
    isLogin() {
      return this.$store.getters['auth/isLogin']
    },
    normalCarts() {
      return this.$store.getters['cart/normalCarts']
    },
    subscriptionCarts() {
      return this.$store.getters['cart/subscriptionCarts']
    },
    form() {
      return {
        normalCarts: this.normalCarts,
        subscriptionCarts: this.subscriptionCarts,
      }
    },
    isSubscription: {
      get() {
        return this.$store.getters['cart/subscription']
      },
      set(val) {
        this.$store.commit('cart/SET_SUBSCRIPTION', val)
      },
    },
    freeAmount: {
      get() {
        return this.$store.getters['cart/freeAmount']
      },
      set(val) {
        this.$store.commit('cart/SET_FREE_AMOUNT', val)
      },
    },
    shippingFee: {
      get() {
        return this.$store.getters['cart/shippingFee']
      },
      set(val) {
        this.$store.commit('cart/SET_SHIPPING_FEE', val)
      },
    },
    normalCartsSummary: {
      get() {
        return this.$store.getters['cart/normalCartsSummary']
      },
      set(val) {
        this.$store.commit('cart/SET_NOMAL_CARTS_SUMMARY', val)
      },
    },
    subscriptionCartsSummary: {
      get() {
        return this.$store.getters['cart/subscriptionCartsSummary']
      },
      set(val) {
        this.$store.commit('cart/SET_SUBSCRIPTION_CARTS_SUMMARY', val)
      },
    },
    isSubscriptionTab() {
      return this.tab === EC_LINE003.TABS_TYPE.SUBSCRIPTION
    },
    isNotEmptyCart() {
      return this.isSubscriptionTab
        ? ((this.isLogin &&
            !!this.subscriptionCarts.filter((i) => i.visible && i.is_product_sku_valid && !i.is_out_stock).length) ||
            (!this.isLogin && !!this.subscriptionCarts.length)) &&
            !!this.subscriptionCartsSummary
        : ((this.isLogin &&
            !!this.normalCarts.filter((i) => i.visible && i.is_product_sku_valid && !i.is_out_stock).length) ||
            (!this.isLogin && !!this.normalCarts.length)) &&
            !!this.normalCartsSummary
    },
    validatelumpSumPayment() {
      return (
        !!this.isSubscription &&
        this.subscriptionCarts.some((i) => i.lump_sum_payment_flag) &&
        !this.subscriptionCarts.every(
          (i) => i.lump_sum_payment_flag && i.lump_sum_payment_num === this.subscriptionCarts[0].lump_sum_payment_num
        )
      )
    },
    summaryStatus() {
      return !!this.subscriptionCartsSummary?.status || !!this.normalCartsSummary?.status
    },
    hasCartItemQuantity() {
      return (
        this.subscriptionCarts.some((item) => item.quantity > 0) || this.normalCarts.some((item) => item.quantity > 0)
      )
    },
    shopId() {
      return this.$store.getters['env/GET_KEY'](ENV_KEY.SHOP_ID)
    },
    clientId() {
      return this.$store.getters['env/GET_KEY'](ENV_KEY.CLIENT_ID)
    },
    cartAbandonmentFlags() {
      return this.$store.getters['cartTracking/cartAbandonmentFlags']
    },
    // ShopECのカート画面では会員のみカゴ落ちを検知する為、非会員パターンを含めない
    isCartAbandonment() {
      const flag = this.cartAbandonmentFlags

      if (!flag || !flag.ec_flag) return false

      return flag.customer_target_flag && !!this.user
    },
    getPayloadCartTrackingData() {
      return this.$store.getters['cartTracking/cartTrackingData'] || {}
    },
  },
  created() {
    this.fetchData()
    this.closeMessage()
    this.logoutAmazon()
  },
  beforeDestroy() {
    this.removeErrorCartItems()
  },
  methods: {
    closeMessage() {
      const that = this
      setTimeout(() => that.$message.closeAll(), 1000)
    },
    async fetchData() {
      this.loading = true
      await this.trackAbandonmentUrlClick()
      await this.fetchItems()
      await this.fetchCartAbandonmentSetting()
      this.loading = false
    },
    async fetchItems(handleChange = false) {
      this.componentLoading = handleChange
      try {
        if (this.isLogin) {
          await syncCart()
        } else {
          const [normalCarts, subscriptionCarts] = await Promise.all([
            this.fetchNormalItems(),
            this.fetchSubscriptionItems(),
          ])

          const carts = await this.checkCarts([...normalCarts, ...subscriptionCarts])
          this.$store.commit('cart/SET_CART', carts)
        }

        this.tab = this.isSubscription ? EC_LINE003.TABS_TYPE.SUBSCRIPTION : EC_LINE003.TABS_TYPE.NORMAL

        if (this.isSubscription && !this.subscriptionCarts.length) {
          this.tab = EC_LINE003.TABS_TYPE.NORMAL
        } else if (!this.isSubscription && !this.normalCarts.length) {
          this.tab = EC_LINE003.TABS_TYPE.SUBSCRIPTION
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
        this.componentLoading = false
      }
    },
    async fetchNormalItems() {
      const product_sku_ids = this.normalCarts.map((i) => i.id + ':' + i.quantity).join()

      if (product_sku_ids) {
        const { data } = await ProductService.getProductSku({
          is_subscription: 0,
          product_sku_ids,
          customer_id: this.user && this.user.id,
        })

        const items = this.normalCarts.map((i) => {
          const sku_detail = data.items.find((j) => j.id === i.id)
          return Object.assign({
            ...i,
            ...sku_detail,
            product_image:
              (sku_detail?.product_image &&
                `${this.$store.getters['env/GET_KEY'](ENV_KEY.IMAGE_API)}/${sku_detail.product_image}`) ||
              null,
          })
        })
        this.normalCartsSummary = data.summary

        return items
      }
      return []
    },
    async fetchSubscriptionItems() {
      const product_sku_ids = this.subscriptionCarts.map((i) => i.id + ':' + i.quantity).join()

      if (product_sku_ids) {
        const { data } = await ProductService.getProductSku({
          is_subscription: 1,
          product_sku_ids,
          customer_id: this.user && this.user.id,
        })

        const items = this.subscriptionCarts.map((i) => {
          const sku_detail = data.items.find((j) => j.id === i.id)
          return Object.assign({
            ...i,
            ...sku_detail,
            product_image: `${this.$store.getters['env/GET_KEY'](ENV_KEY.IMAGE_API)}/${sku_detail?.product_image}`,
          })
        })
        this.subscriptionCartsSummary = data.summary

        return items
      }
      return []
    },
    async checkCarts(carts) {
      const { data: cartsCheck } = await CartService.checkCart(
        carts.map((i) =>
          Object.assign({
            product_sku_id: i.id,
            sale_type: i.sale_type,
            quantity: i.quantity,
            sale_limit: i.sale_limit,
          })
        )
      )

      return carts.map((i) => {
        const skuCheck = cartsCheck.find((j) => j.product_sku_id === i.id)

        return Object.assign({
          ...i,
          visible: skuCheck?.visible,
          is_product_sku_valid: skuCheck?.is_product_sku_valid,
        })
      })
    },
    updateQuantity(payload) {
      this.$store.dispatch('cart/UPDATE_QUANTITY_ITEM', payload).then(() => {
        this.fetchItems(true).then(() => {
          this.fetchCartAbandonmentSetting()
        })
      })
    },

    validateForm() {
      return new Promise((resolve) => {
        this.isSubscription
          ? this.$refs.subscriptionForm.validate((valid) => resolve(valid))
          : this.$refs.normalForm.validate((valid) => resolve(valid))
      })
    },
    async toCashRegiter() {
      try {
        this.loading = true
        this.isSubscription = this.isSubscriptionTab
        const valid = await this.validateForm()
        if (!valid) {
          this.handleError({ message: this.$t('common.messages.hasInvalidData') })
          return
        }
        if (!this.isLogin) {
          localStorage.setItem(
            this.Constants.LOCAL_CART,
            JSON.stringify({
              carts: [...this.normalCarts, ...this.subscriptionCarts],
              subscription: this.isSubscription,
              normalCartsSummary: this.normalCartsSummary,
              subscriptionCartsSummary: this.subscriptionCartsSummary,
            })
          )
        }

        this.isSubscription
          ? this.$router.push({ path: this.$routePage.EC_LINE029_001 })
          : this.$router.push({ path: this.$routePage.EC_LINE029_002 })
      } finally {
        this.loading = false
      }
    },
    async removeErrorCartItems() {
      const currentCarts = this.isSubscriptionTab ? this.subscriptionCarts : this.normalCarts
      const errorCarts = currentCarts.filter((i) => !i.visible || i.is_product_sku_valid === false || i.is_out_stock)

      await Promise.all(errorCarts.map((i) => this.removeItem(i)))
    },
    async removeItem({ id, subscription }) {
      this.$store.dispatch('cart/REMOVE_CART_ITEM', { id, subscription: Number(subscription) }).then(() => {
        this.fetchItems(true).then(() => {
          this.fetchCartAbandonmentSetting()
        })
      })
    },

    toProductPage() {
      this.$router.push({ path: this.$routePage.EC_LINE001 })
    },

    logoutAmazon() {
      if (this.isLoginAmazon) {
        this.onAmazonLogout(AMAZON.ACCESS_TOKEN_029)
      }
    },
    handleTabClick() {
      this.isSubscription = this.isSubscriptionTab
    },
    fetchCartAbandonmentSetting() {
      if (this.isCartAbandonment) {
        this.fetchDetectCartAbandonment()
      }
    },
    async fetchDetectCartAbandonment() {
      const toDayDate = new Date().getTime()
      const cartItems = this.isSubscription
        ? this.subscriptionCarts.map((item) => ({
            product_id: item.product_id,
            product_sku_id: item.id,
            quantity: item.quantity,
            price: item.price03_after_tax,
          }))
        : this.normalCarts.map((item) => ({
            product_id: item.product_id,
            product_sku_id: item.id,
            quantity: item.quantity,
            price: item.price02_after_tax,
          }))

      if (cartItems.length > 0) {
        const body = {
          id: localStorage.getItem('tracking_id') ? localStorage.getItem('tracking_id') : null,
          client_id: this.clientId,
          shop_id: this.shopId,
          tracking_start_date: toDayDate,
          customer_id: this.user ? this.user.id : null,
          email: this.user ? this.user.email : null,
          phone_number: this.user ? this.user.phone_number : null,
          line_id: this.user ? this.user.line_id : null,
          device_type_id: this.Utils.helper.deviceType(this.$store.state.auth.shop),
          payment_total: this.isSubscription
            ? Number(this.subscriptionCartsSummary.payment_total)
            : Number(this.normalCartsSummary.payment_total),
          adjustment_amount: this.isSubscription
            ? Number(this.subscriptionCartsSummary.adjustment_amount)
            : Number(this.normalCartsSummary.adjustment_amount),
          delivery_fee: this.isSubscription
            ? Number(this.subscriptionCartsSummary.delivery_fee)
            : Number(this.normalCartsSummary.delivery_fee),
          subscription_flag: this.isSubscription,
          cart_items: [...cartItems],
          cart_type_id: this.Constants.SYSTEM_TYPE.SHOP_EC,
          url_clicked: !!this.abmtcd || this.getPayloadCartTrackingData.url_clicked,
        }

        const responseUpdateCartAbandonmentSetting = await CartService.updateCartAbandonmentSetting(
          removeEmptyQueryString(body)
        )

        localStorage.setItem('tracking_id', responseUpdateCartAbandonmentSetting.data.id)

        this.$store.dispatch('cartTracking/SET_CART_TRACKING', {
          tracking_id: responseUpdateCartAbandonmentSetting.data.id,
          cart_type_id: this.Constants.SYSTEM_TYPE.SHOP_EC,
          tracking_start_date: responseUpdateCartAbandonmentSetting.data.tracking_start_date,
          customer_id: responseUpdateCartAbandonmentSetting.data.customer_id,
          email: responseUpdateCartAbandonmentSetting.data.email,
          phone_number: responseUpdateCartAbandonmentSetting.data.phone_number,
          line_id: responseUpdateCartAbandonmentSetting.data.line_id,
          url_clicked: !!this.abmtcd || this.getPayloadCartTrackingData.url_clicked,
        })
      }
    },
    async trackAbandonmentUrlClick() {
      if (!this.abmtcd) return

      const body = {
        code: this.abmtcd,
      }
      try {
        const { data } = await CartService.trackAbandonmentUrlClick(body)
        localStorage.setItem('tracking_id', data.id)
        this.$store.dispatch('cartTracking/SET_CART_TRACKING', {
          tracking_id: data.id,
          cart_type_id: null, // 購入画面（LPカート/ショップEC）を判断するID
          tracking_start_date: null,
          customer_id: null,
          email: null,
          phone_number: null,
          line_id: null,
          url_clicked: !!this.abmtcd,
        })
        if (!this.isLogin && this.normalCarts.length < 1 && this.subscriptionCarts.length < 1) {
          this.handleAbandonmentUrlClick(data)
        }
      } catch (error) {
        // do nothing
      }
    },
    handleAbandonmentUrlClick(data) {
      if (data.cart_items.length <= 0) return

      const productList = data.cart_items.map((item) => {
        return Object.assign({
          id: item.product_sku_id,
          product_id: item.product_id,
          quantity: item.quantity,
          sale_type: item.subscription ? SALE_TYPE.SUBSCRIPTION : SALE_TYPE.NORMAL,
          subscription: data.subscription_flag,
        })
      })

      this.$store.commit('cart/SET_CART', productList)
    },
  },
  metaInfo() {
    return {
      title: this.$t('ec-line003.title'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('ec-line003.description', { shop_name: this.shopName }),
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.$t('ec-line003.keyword', { shop_name: this.shopName }),
        },
        {
          vmid: 'robots',
          name: 'robots',
          content: this.Constants.META_TAG.NO_INDEX_NO_FOLLOW,
        },
      ],
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/css/pages/line_web003.scss';
</style>
